"use client";

import ImageAtom from "@components/atoms/Image";
import styles from "./NotAvailableContainer.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { useEffect } from "react";
import { trackSystemError } from "@utils/exceptionTracker";
import Button from "@components/atoms/Button";
import { usePathname, useRouter } from "next/navigation";
import { PAGE_TYPES } from "@constants/pageTypes";
import { useGlobalLoader } from "@hooks/useGlobalLoader";

interface NotAvailableContainerProps {
  type: string;
  error: string;
}

function getPageTypeFromPath(pathname: string): string {
  if (pathname.includes('/dimensions')) {
    return PAGE_TYPES.DIMENSIONS_PAGE;
  }
  if (pathname.includes('/price')) {
    return PAGE_TYPES.PRICE_PAGE;
  }
  if (pathname.includes('/variants')) {
    return PAGE_TYPES.VARIANT_PAGE;
  }
  if (pathname.includes('/gallery')) {
    return PAGE_TYPES.GALLERY_PAGE;
  }
  if (pathname.includes('/specifications')) {
    return PAGE_TYPES.SPECS_PAGE;
  }
  if (pathname.includes('/colours')) {
    return PAGE_TYPES.COLOURS_PAGE;
  }
  if (pathname.includes('/mileage')) {
    return PAGE_TYPES.MILEAGE_PAGE;
  }
  if (pathname.includes('/review')) {
    return PAGE_TYPES.REVIEW_PAGE;
  }
  if (pathname.includes('/cars/') && pathname.split('/').length > 3) {
    return `${PAGE_TYPES.MM_PAGE} or ${PAGE_TYPES.MMV_PAGE}`;
  }
  return PAGE_TYPES.NOT_FOUND_PAGE;
}

export default function NotAvailableContainer({
  type,
  error,
}: NotAvailableContainerProps) {

  const pathname = usePathname();
  const router = useRouter();
  const page_type = getPageTypeFromPath(pathname);
  const { showLoader, hideLoader } = useGlobalLoader();

  useEffect(() => {
    hideLoader();
  }, [pathname, hideLoader]);
  
  useEffect(() => {
    trackSystemError("page_unavailable", page_type, {
      type,
      slug: pathname,
    });
  }, [error]);

  const handleClick = () => {
    showLoader('Loading...');
    router.push('/cars/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <ImageAtom
          src={`${assetLoader()}/images/nocontent.svg`}
          alt="not-available"
          width={361}
          height={181}
        />
      </div>

      <h1 className={styles.title}>Content Not Available</h1>

      <p className={styles.description}>{error}</p>

      <div className={styles.actions}>
        <Button
          className={styles.secondaryButton}
          onClick={() => handleClick()}
        >
          Browse Cars
        </Button>
      </div>
    </div>
  );
}
